import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Supplier } from "@/v2/types";

export default async function FindOneSupplier(id: string): Promise<Supplier> {
    const res = await apiClientWithRefreshToken({
        url: `/suppliers/${id}`,
        method: "GET",
    });

    return res.data;
}
